<template>
	<div>
		<v-navigation-drawer
			width="450"
			disable-resize-watcher
			app
			right
			temporary
			v-model="showNavModal"
			class="elevation-0"
			fixed
			style="z-index: 201;"
		>
			<div style="width: 100%; height: 50px; display: flex; flex-direction: row; justify-content: flex-end;">
				<v-btn style="height: 64px; width: 64px;" flat @click="showNavModal = !showNavModal" class="hidden-xs-only">
					<v-icon large style="color: #AAA">fal fa-times</v-icon>
				</v-btn>
				<v-btn style="min-width: 56px; height: 56px; width: 56px;" flat @click="showNavModal = !showNavModal" class="hidden-sm-and-up">
					<v-icon large style="color: #AAA">fal fa-times</v-icon>
				</v-btn>
			</div>
			<v-list two-line class="pa-3 pt-1" v-if="userIsAuthenticated">
				<v-list-tile avatar @click="routeTo('/profile/me')">
					<v-list-tile-avatar>
						<img :src="user.avatar + '?w=50'" />
					</v-list-tile-avatar>
					<v-list-tile-content>
						<v-list-tile-title>{{ user.first_name }} {{ user.last_name }}</v-list-tile-title>
						<span class="nav-drawer__subtitle">Profile, Account, Settings</span>
					</v-list-tile-content>
				</v-list-tile>
			</v-list>
			<v-divider v-if="userIsAuthenticated" inset></v-divider>
			<v-list two-line class="pa-3 pt-0" :style="{ 'margin-top': userIsAuthenticated ? '0px' : '70px'}">
				<template v-for="item in menuItems">
					<v-subheader v-if="item.header" v-text="item.header" :key="item.title"></v-subheader>
					<v-divider class="mt-3 mb-3" v-else-if="item.divider" v-bind:inset="item.inset" :key="item.title"></v-divider>
					<v-list-tile v-else :key="item.title" @click="routeTo(item.link)" :id="'navBtn-'+item.title.replace(' ', '').toLowerCase()">
						<v-list-tile-avatar size="24">
							<v-icon v-if="item.title == 'Messages'" left 
								:style="{ 'color': (item.title === 'Logout' || item.title === 'Terms') ? '#CCC' : '#777' }"
								:class="{'fas': true, 'fa-users': true, 'badge': unreadNotifications}"
							>
								{{item.icon}}
							</v-icon>
							<v-icon v-else left :style="{ 'color': (item.title === 'Logout' || item.title === 'Terms') ? '#CCC' : '#777' }">
								{{item.icon}}
							</v-icon>
							<!-- <i class="fas fa-handshake"></i> -->
						</v-list-tile-avatar>
						<v-list-tile-content>
							<v-list-tile-title v-html="item.title" :style="{ 'color': (item.title === 'Logout' || item.title === 'Terms') ? '#AAA' : '#666' }"></v-list-tile-title>
							<span class="nav-drawer__subtitle">{{item.subtitle}}</span>
						</v-list-tile-content>
					</v-list-tile>
				</template>
			</v-list>
		</v-navigation-drawer>
		<!-- 
			TOOLBAR
		 -->
		<!-- <v-toolbar ref="navbar" app fixed flat :class="[getTransparentNavbarClass, navbarScrollClass, 'navbar-style scrolling scrolling--up']"> -->
		<v-toolbar ref="navbar" absolute app flat :class="[getTransparentNavbarClass, 'scroll-away navbar-style']" :style="getToolbarStyle">			
			<v-toolbar-title :style="getHomepageStyle">
				<img @click="clickNavLogo" src="/static/images/navbar/logo-color.svg" height="35" style="margin-top: 6px; cursor: pointer;" alt="wrkprty_logo" />
				<span v-if="onHomepage && !isMobile" class="quantico toolbar-text-title">wrkprty</span>
			</v-toolbar-title>
			<v-spacer></v-spacer>
		<!--	<div v-if="onHomepage && !isMobile" class="toolbar-homepage-button-container">
				<v-btn flat @click="setAuthModalOpen(true)" class="toolbar-homepage-button"><p>Join</p></v-btn>
				<div class="toolbar-button-vertical-divider"></div>
				<v-btn flat @click="setAuthModalOpen(true)" class="toolbar-homepage-button"><p>Sign in</p></v-btn>
			</div> -->
			<v-toolbar-items class="hidden-xs-only">
				<v-tooltip bottom v-for="(item, i) in menuItems" :key="i">
					<v-btn
						slot="activator"
						flat
						v-if="item.link && item.primary"
						@click="routeTo(item.link)"
						:class="[getTransparentButtonClass, 'navbar-style']"
					>
						<v-icon medium :class="getClass(item)" v-html="item.icon">
						</v-icon>
					</v-btn>
					<span>{{ item.title }}</span>
				</v-tooltip>
				<v-btn flat @click="showNavModal = !showNavModal" :class="[getTransparentButtonClass, 'hidden-xs-only navbar-style']" id="nav-drawer-button-desktop">
					<div id="nav-icon1" :class="{ 'open': showNavModal }">
						<span :style="getHamburgerMenuStyle"></span>
						<span :style="getHamburgerMenuStyle"></span>
						<span :style="getHamburgerMenuStyle"></span>
					</div>
				</v-btn>
			</v-toolbar-items>

			<v-btn icon flat @click="showNavModal = !showNavModal" :class="[getTransparentButtonClass, 'hidden-sm-and-up navbar-style']">
				<div id="nav-icon1" :class="{ 'open': showNavModal }">
					<span :style="getHamburgerMenuStyle"></span>
					<span :style="getHamburgerMenuStyle"></span>
					<span :style="getHamburgerMenuStyle"></span>
				</div>
			</v-btn>
		</v-toolbar>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import scrollDir from 'scrolldir'
export default {
	data() {
		return {
			active: null,
			navbarShouldTurnWhite: false,
			showNavModal: false,
			mobileNav: 'recent',
			title: 'wrkprty',
			scrollThreshold: 64,
			scrollPos: 0,
			lastScrollPos: 0,
			didScroll: false,
			navbarScrollClass: 'nav-down'
		}
	},
	watch: {
		$route(to, from) {
			this.navbarScrollClass = 'nav-down'
			this.scrollPos = window.scrollY
			this.lastScrollPos = window.scrollY
			this.showNavModal = false
			this.navbarShouldTurnWhite = false
			this.updateActive()
		},
		showNavModal(newVal, oldVal) {
			let routeName = this.$router.history.current.name
			if (routeName === 'root') {
				if (this.userIsAuthenticated) {
					routeName = 'user_dashboard'
				} else {
					routeName = 'landing_page'
				}
			}
			if (newVal === true) {
				document.documentElement.classList.add('overflow-hidden')
			} else {
				document.documentElement.classList.remove('overflow-hidden')
			}
		}
	},
	created () {
		// scrollDir()
		scrollDir({ dir: 'up' })
		this.updateActive()
		window.addEventListener('scroll', this.handleScroll)
		// setInterval(() => {
		// 	if (this.didScroll) {
		// 		let st = window.scrollY
		// 		let windowHeight =
		// 			window.innerHeight ||
		// 			document.documentElement.clientHeight ||
		// 			document.body.clientHeight
		// 		const body = document.body
		// 		const html = document.documentElement

		// 		var documentHeight = Math.max(
		// 			body.scrollHeight,
		// 			body.offsetHeight,
		// 			html.clientHeight,
		// 			html.scrollHeight,
		// 			html.offsetHeight
		// 		)

		// 		// Make sure they scroll more than delta
		// 		if (Math.abs(this.lastScrollTop - st) <= this.scrollThreshold) {
		// 			return null
		// 		}
		// 		// If they scrolled down and are past the navbar, add class .nav-up.
		// 		// This is necessary so you never see what is "behind" the navbar.
		// 		if (st > this.lastScrollTop && st > this.scrollThreshold) {
		// 			// Scroll Down
		// 			this.navbarScrollClass = 'nav-up'
		// 			setTimeout(() => {
		// 				this.navbarShouldTurnWhite = true
		// 			}, 501)
		// 		} else {
		// 			// Scroll Up
		// 			if (st + windowHeight < documentHeight) {
		// 				this.navbarScrollClass = 'nav-down'
		// 			}
		// 		}
		// 		this.lastScrollTop = st
		// 		this.didScroll = false
		// 	}
		// }, 200)
	},
	methods: {
		...mapActions([
			'setAuthModalOpen',
			'setModalOpen',
			'setModalOpen',
			'logout'
		]),
		updateActive() {
			for (let i = 0; i < this.menuItems.length; i++) {
				if (
					this.$route.name === this.menuItems[i].link ||
					this.$route.path === this.menuItems[i].link
				) {
					this.active = this.menuItems[i].link
					break
				}
			}
		},
		getClass(item) {
			let c = ''
			if (item.link === this.active) {
				if (this.getShouldBeTransparent) {
					c += 'nav-button__transparent-active'
				} else {
					c += 'nav-button__solid-active'
				}
			} else {
				if (this.getShouldBeTransparent) {
					c += 'nav-button__transparent-inactive'
				} else {
					c += 'nav-button__solid-inactive'
				}
			}
			if (this.unreadNotifications && item.title === 'Messages') {
				c += ' nav-badge'
			}
			return c
		},
		clickNavLogo() {
			if (this.getAuthModalOpen) {
				this.setAuthModalOpen(false)
			} else if (this.showNavModal) {
				this.showNavModal = false
			} else {
				this.$router.push('/')
				// window.location = '/'
			}
		},
		mobileClickSignin() {
			this.drawer = false
			this.setAuthModalOpen(true)
		},
		mobileClickLogout() {
			this.drawer = false
			this.logout()
		},
		routeTo(url) {
			this.showNavModal = false
			if (url === 'logout') {
				this.logout()
			} else if (url === 'login') {
				this.setAuthModalOpen(true)
			} else if (url === 'contact') {
				this.setModalOpen({ prop: 'contactForm', value: true })
			} else if (url === 'terms') {
				this.setModalOpen({ prop: 'termsModal', value: true })
			} else if (url === 'about') {
				this.setModalOpen({ prop: 'aboutUsModal', value: true })
			} else {
				this.$router.push(url)
			}
		},
		handleScroll(event) {
			this.didScroll = true
			this.scrollPos = window.scrollY
			if (this.scrollPos < this.scrollThreshold) {
				this.navbarShouldTurnWhite = false
			}
		}
	},
	computed: {
		...mapGetters([
			'getAuthModalOpen',
			'userIsAuthenticated',
			'userIsHost',
			'user',
			'userHasHostRequest',
			'getNotifications'
		]),
		isMobile() {
			if (this.$vuetify.breakpoint.name === 'xs') {
				return true
			} else {
				return false
			}
		},
		onHomepage () {
			if (this.$route.name === 'root' && !this.userIsAuthenticated) {
				return true
			}
		},
		getToolbarStyle () {
			if (this.onHomepage && !this.isMobile) {
				return {
					'height': '100px',
					'padding': '10px 15px 0 15px'
				}
			}
		},
		getHomepageStyle () {
			if (this.onHomepage && this.isMobile) {
				return {
					'margin-left': '15px',
					'margin-top': '5px'
				}
			} else if (this.onHomepage) {
				return {
					'width': '200px'
				}
			}
		},
		unreadNotifications () {
			console.log(this.getNotifications)
			for (var i = 0; i < this.getNotifications.length; i++) {
				if (this.getNotifications[i]) {
					if (this.getNotifications[i].read === false) {
						return true
					}
				}
			}
		},
		getHamburgerMenuStyle() {
			let backgroundColor
			if (this.onHomepage) {
				backgroundColor = '#AAA'
			} else if (this.getShouldBeTransparent) {
				backgroundColor = this.showNavModal ? '#FFF' : '#FAFAFA'
			} else {
				backgroundColor = this.showNavModal ? '#777' : '#CCC'
			}
			return {
				color: backgroundColor,
				background: backgroundColor
			}
		},
		getShouldBeTransparent() {
			// if (this.showNavModal || this.getAuthModalOpen) {
			if (this.getAuthModalOpen) {
				return true
			}
			if (!this.userIsAuthenticated) {
				if (
					this.scrollPos > this.scrollThreshold &&
					this.navbarShouldTurnWhite
				) {
					return false
				}
				return true
			}
			if (
				this.$route.name === 'host_info' ||
				this.$route.name === 'event' ||
				this.$route.name === 'location' ||
				this.$route.name === 'profile'
			) {
				if (
					this.scrollPos > this.scrollThreshold &&
					this.navbarShouldTurnWhite
				) {
					return false
				}
				return true
			}
			if (this.$route.name === 'root') {
				if (this.userIsAuthenticated) {
					return false
				}
				return true
			} else {
				return false
			}
		},
		getTransparentNavbarClass() {
			if (this.getShouldBeTransparent) {
				return 'transparent'
			} else {
				return 'solid'
			}
		},
		getTransparentButtonClass() {
			if (this.getShouldBeTransparent) {
				return 'transparent--btn'
			} else {
				return 'solid--btn'
			}
		},
		menuItems() {
			let menuItems = [
				// { header: 'Account' },
				{ title: 'Join &nbsp;|&nbsp; Sign In', icon: 'fas fa-sign-in', link: 'login' },
				{ divider: true, inset: true }
			]
			if (this.userIsAuthenticated) {
				menuItems = [
					// { header: 'Navigation' },
					{
						title: 'Dashboard',
						subtitle: 'Home',
						icon: 'fas fa-home',
						primary: false,
						link: '/dashboard'
					},
					// { divider: true, inset: true },
					{
						title: 'Upcoming Events',
						subtitle: 'Explore, Browse, Search',
						icon: 'fas fa-search',
						primary: true,
						link: '/events'
					},
					{
						title: 'Wishlist',
						subtitle: 'My Saved Favorites',
						icon: 'fas fa-heart',
						primary: true,
						link: '/saved'
					},
					{
						title: 'Calendar',
						subtitle: 'My event reservations & bookings',
						icon: 'fas fa-calendar-check',
						primary: true,
						link: '/calendar'
					},
					{
						title: 'Messages',
						subtitle: 'Notifications & Alerts',
						icon: 'fas fa-comment',
						iconSolid: 'fas fa-comment',
						primary: true,
						link: '/messages'
					}
					// { divider: true, inset: true },
				]
			}
			if (this.userIsHost || this.userHasHostRequest) {
				menuItems = menuItems.concat([
					// { header: 'Host' },
					{ divider: true, inset: true },
					{
						title: 'Host Dashboard',
						subtitle: 'Hosting Tips, Tools & Support',
						icon: 'fas fa-handshake',
						primary: false,
						link: '/host/dashboard'
					},
					{ divider: true, inset: true }
				])
			}
//			if (
//				!this.userIsHost &&
//				this.userIsAuthenticated &&
//				!this.userHasHostRequest
//			) {
//				menuItems = menuItems.concat([
//					{ divider: true, inset: true },
//					// { header: 'Host' },
//					{
//						title: 'Become a Host',
//						icon: 'fas fa-handshake',
//						primary: false,
//						link: '/host/info'
//					},
//					{ divider: true, inset: true }
//				])
//			}


			menuItems = menuItems.concat([
				// { header: 'wrkprty' },
				
				{
					title: 'About Us',
					subtitle:
						'Learn about wrkprty, our mission, and what we are building',
					icon: 'fas fa-building',
					link: 'about'
				},
			])
			if (
				!this.userIsAuthenticated
			) {
				menuItems = menuItems.concat([
					// { header: 'Host' },
					{
						title: 'Become a Host',
						icon: 'fas fa-handshake',
						primary: false,
						link: '/host/info'
					},
				])
			}
			menuItems = menuItems.concat([
				{
					title: 'Contact',
					subtitle:
						"We're here to Support, Help, and take your Questions or Feedback",
					icon: 'fas fa-envelope',
					link: 'contact'
				},
				{ divider: true, inset: true }
			])
			if (this.userIsAuthenticated) {
				menuItems = menuItems.concat([
					// { header: 'User' },
					// { title: 'Profile', icon: 'fa-user', link: '/profile/me' },
					// { divider: true, inset: true },
					// { header: 'Account' },
					// { title: 'Settings', subtitle: 'View and update your account settings', icon: 'fas fa-cog', link: '/user/settings' },
					// { divider: true, inset: true },
					{
						title: 'Logout',
						subtitle:
							'Only suggested when accessing wrkprty from a shared device',
						icon: 'fas fa-sign-out',
						link: 'logout'
					},
					{ divider: true, inset: true }
				])
			}
			menuItems = menuItems.concat([
				{
					title: 'Terms',
					subtitle:
						'Terms, Privacy, Payments, and other conditions of using this site',
					icon: 'fas fa-book',
					link: 'terms'
				}
				// { divider: true, inset: true }
			])
			return menuItems
		}
	}
}
</script>

<style lang="scss">
.toolbar-homepage-button-container {
	display: flex;
	align-items: center;
}
.toolbar-button-vertical-divider {
	display: inline;
	margin: 0;
	width: 1px;
	height: 15px;
	border-left: 1px solid #AAA;
	margin-top: 1px;
	margin-right: 8px;
}
.toolbar-homepage-button {
	width: 70px;
	min-width: 70px;
	p {
		font-weight: 300!important;
		font-family: 'Nunito', sans-serif!important;
		font-size: 1.25em;
		color: #DDD!important;
		margin: 0;
	}
}
.toolbar-text-title {
	color: #ffffffb3;
	position: relative;
	font-weight: bolder;
	letter-spacing: 1px;
	font-size: 1.4em;
	bottom: 9px;
	left: 25px;

	display: inline-block;
	-webkit-transform: scale(1.25,1);
	-moz-transform: scale(1.25,1);
	-ms-transform: scale(1.25,1);
	-o-transform: scale(1.25,1);
	transform: scale(1.25,1);
}

.nav-drawer__subtitle {
	color: #aaa;
	font-size: 0.75em;
}

.navbar-style {
	-webkit-transition: background-color 0.5s, top 0.5s ease-in-out !important;
	transition: background-color 0.5s, top 0.5s ease-in-out !important;
	-webkit-box-shadow: none;
	-moz-box-shadow: none;
	box-shadow: none;
	// .icon.transparent--btn {
	// 	color: #ffffff !important;
	// }
	// .icon.solid--btn {
	// 	color: #777 !important;
	// }
}

.nav-down {
	top: 0 !important;
}

.nav-up {
	top: -68px !important;
}

.transparent {
	background-color: transparent !important;
}

.solid {
	background-color: #f5f5f5 !important;
}

.nav-button__transparent-active {
	color: white !important;
}
.nav-button__transparent-inactive {
	color: #fafafa !important;
}

.nav-button__solid-active {
	color: #777 !important;
}
.nav-button__solid-inactive {
	color: #ccc !important;
}

.nav-badge:after{
	content: '';
	position: absolute;
	background: #de6455;
	height:1em;
	top:1.3em;
	left:3.6em;
	width:1em;
	line-height: 2em;
	font-size: 1rem;
	border-radius: 50%;
}

.scroll-away {
	top: -91px;
	transition: top .5s ease;
	[data-scrolldir=up] & {
		top: 0;
	}
}
</style>
